import { Bar, mixins } from "vue-chartjs";

export default Bar.extend({
  mixins: [mixins.reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    const options = {
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            barPercentage: 1,
            categoryPercentage: 0.9
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: true,
              borderDash: [4],
              color: "#e0e8f0",
              lineWidth: 1
            }
          }
        ]
      },
      maintainAspectRatio: false
    };
    this.renderChart(this.chartData, options);
  }
});
